import { useForm } from "@mantine/form";
import {
  Textarea,
  NumberInput,
  Button,
  Group,
  Container,
  Chips,
  Chip,
  Text,
  LoadingOverlay,
  useMantineTheme,
} from "@mantine/core";
import Toast from "./../Toast";
import "./Grade.css";
import PropTypes from "prop-types";
import { useState } from "react";
import { addGradeApi, editGradeApi } from "./../../api/tasks";
import { useMediaQuery } from "@mantine/hooks";

async function editGrade(values) {
  var obj = {};
  for (var index in values.fields) {
    obj.userId = values.userId;
    if (values[String(values.fields[index])] == null) {
      Toast("Fill the choosed fields", "", "red");
      return;
    }
    obj[String(values.fields[index])] = values[String(values.fields[index])];
  }
  obj.taskId = values.taskId;
  if (obj.userId == null) {
    Toast("Choose atleast one edit field", "", "red");
    return;
  }
  const res = await editGradeApi(values, obj).catch((err) => {
    Toast(
      "ERROR",
      err.response != null
        ? err.response.data != null
          ? err.response.data.message != null
            ? err.response.data.message
            : err.message
          : err.message
        : err.message,
      "red"
    );
    if (err.response.status == 401 || err.response.status == 403) {
      localStorage.clear();
      window.location.replace("/");
    }
  });
  if (res != null) {
    if (res.status == 200) {
      Toast("Success", res.data.message, "green");
      return obj;
    } else {
      Toast("ERROR", res.data.message, "red");
      return;
    }
  } else return;
}

async function addGrade(values) {
  const res = await addGradeApi(values).catch((err) => {
    Toast(
      "ERROR",
      err.response != null
        ? err.response.data != null
          ? err.response.data.message != null
            ? err.response.data.message
            : err.message
          : err.message
        : err.message,
      "red"
    );
    if (err.response.status == 401 || err.response.status == 403) {
      localStorage.clear();
      window.location.replace("/");
    }
  });
  if (res != null) {
    if (res.status == 200) {
      Toast("Success", res.data.message, "green");
      return true;
    } else {
      Toast("ERROR", res.data.message, "red");
      return;
    }
  } else return;
}

// THIS FUNCTION IS IMPORTED IN SUBMMISION.JS
export default function Grade({ submission, isChange }) {
  const [isLoad, setLoad] = useState(false);
  const [subsmissionDetails, setSubmission] = useState(submission.submission);
  const isScreenLarge = useMediaQuery("(min-width: 400px)", false);
  var theme = useMantineTheme();
  const form = useForm({
    initialValues: {
      marks: undefined,
      penalty: 0,
      remarks: "",
      taskId: submission.id,
      userId: submission.userId,
    },
    validate: (values) => ({
      marks:
        values.marks === undefined
          ? "Marks is required"
          : values.marks < 0 || values.marks > 100
          ? "Marks must be in range (0-100) "
          : null,
    }),
  });
  const editForm = useForm({
    initialValues: {
      marks: undefined,
      penalty: 0,
      remarks: "",
      taskId: submission.id,
      fields: [],
      userId: submission.userId,
    },
    validate: (values) => ({
      marks:
        values.marks === undefined
          ? null
          : values.marks < 0 || values.marks > 100
          ? "Marks must be in range (0-100) "
          : null,
    }),
  });

  return (
    <>
      <LoadingOverlay visible={isLoad} />
      <Container
        style={{
          padding: "20px",
          fontSize: isScreenLarge == false ? "11px" : "15px",
        }}
      >
        <div id="submission-data" style={{ fontWeight: "bold" }}>
          <h3>Submission Details</h3>
          <p>Domain: {submission.domain}</p>
          <p>Task: {submission.taskNo}</p>
          <p
            style={{
              display: subsmissionDetails.link == null ? "none" : "block",
            }}
          >
            Link:
            <a
              rel="noreferrer"
              target={"_blank"}
              href={subsmissionDetails.link}
            >
              {" "}
              {subsmissionDetails.link}
            </a>
          </p>
          <p
            style={{
              display: subsmissionDetails.content == null ? "none" : "block",
            }}
          >
            Submission: {subsmissionDetails.content}{" "}
          </p>
          <a
            style={{
              display: subsmissionDetails.file == null ? "none" : "block",
            }}
            href={subsmissionDetails.file}
            download
          >
            <Button
              gradient={{ from: "#0063F8", to: "#3391FF" }}
              variant="gradient"
              style={{
                extDecoration: "none",
                marginRight: "16px",
              }}
            >
              Download
            </Button>
          </a>
        </div>
        <div
          style={{
            padding: "30px",
            marginTop: "20px",
            boxShadow:
              theme.colorScheme === "dark"
                ? "2px 2px 5px rgb(50,50,50)"
                : "2px 2px 5px rgb(220, 220, 220)",
            display: subsmissionDetails.marks != null ? "block" : "none",
          }}
        >
          <div>
            <p>Marks: {subsmissionDetails.marks}</p>
          </div>
          <div>
            <p>Penalty: {subsmissionDetails.penalty}</p>
          </div>
          <div>
            <p>Remarks: {subsmissionDetails.remarks}</p>
          </div>
        </div>
        <div
          className="note"
          style={{
            boxShadow:
              theme.colorScheme === "dark"
                ? "0px 0px 0px rgb(50,50,50)"
                : "0px 0px 0px rgb(220, 220, 220)",
            display:
              submission.subAllowed == false && submission.showResult == false
                ? "block"
                : "none",
          }}
        >
          Evaluation Notes (For evaluation, do consider these points):
          <div>{submission.evalNotes}</div>
        </div>
        <div
          style={{
            padding: "30px",
            marginTop: "20px",
            boxShadow:
              theme.colorScheme === "dark"
                ? "2px 2px 5px rgb(50,50,50)"
                : "2px 2px 5px rgb(220, 220, 220)",
            display:
              subsmissionDetails.marks == null &&
              submission.subAllowed == false &&
              submission.showResult == false
                ? "block"
                : "none",
          }}
        >
          <div>
            <form
              onSubmit={form.onSubmit((values) => {
                setLoad(true);
                addGrade(values).then((isSuccess) => {
                  setLoad(false);
                  if (isSuccess == true) {
                    setSubmission({
                      ...subsmissionDetails,
                      marks: values.marks,
                      penalty: values.penalty,
                      remarks: values.remarks,
                    });
                    isChange(true);
                  }
                });
              })}
            >
              <NumberInput
                mt="sm"
                label="Marks"
                required
                placeholder=" /100 "
                size={isScreenLarge == false ? "xs" : "sm"}
                {...form.getInputProps("marks")}
              />
              <NumberInput
                mt="sm"
                label="Penalty"
                placeholder=""
                size={isScreenLarge == false ? "xs" : "sm"}
                {...form.getInputProps("penalty")}
              />
              <Textarea
                label="Remarks"
                required
                placeholder="Any remarks"
                size={isScreenLarge == false ? "xs" : "sm"}
                {...form.getInputProps("remarks")}
              />

              <Group position="right" mt="md">
                <Button
                  type="submit"
                  gradient={{ from: "#0063F8", to: "#3391FF" }}
                  variant="gradient"
                  style={{
                    backgroundColor: "#00FFF0",
                    fontSize: isScreenLarge == false ? "11px" : "15px",
                  }}
                >
                  Add
                </Button>
              </Group>
            </form>
          </div>
        </div>
        <div
          style={{
            padding: "30px",
            marginTop: "20px",
            boxShadow:
              theme.colorScheme === "dark"
                ? "2px 2px 5px rgb(50,50,50)"
                : "2px 2px 5px rgb(220, 220, 220)",
            display:
              subsmissionDetails.marks != null &&
              submission.subAllowed == false &&
              submission.showResult == false
                ? "block"
                : "none",
          }}
        >
          <div>
            <form
              onSubmit={editForm.onSubmit((values) => {
                setLoad(true);
                editGrade(values).then((obj) => {
                  setLoad(false);
                  if (obj != null) {
                    setSubmission({
                      ...subsmissionDetails,
                      marks:
                        obj.marks != null
                          ? obj.marks
                          : subsmissionDetails.marks,
                      penalty:
                        obj.penalty != null
                          ? obj.penalty
                          : subsmissionDetails.penalty,
                      remarks:
                        obj.remarks != null
                          ? obj.remarks
                          : subsmissionDetails.remarks,
                    });
                    isChange(true);
                  }
                });
              })}
            >
              <Text
                style={{ fontSize: isScreenLarge == false ? "11px" : "15px" }}
              >
                Select Edit Fields
              </Text>
              <Chips
                size={isScreenLarge == false ? "xs" : "sm"}
                multiple
                {...editForm.getInputProps("fields", { type: "chips" })}
              >
                <Chip value="marks">Marks</Chip>
                <Chip value="penalty">Penalty</Chip>
                <Chip value="remarks">Remarks</Chip>
              </Chips>
              <NumberInput
                mt="sm"
                label="Marks"
                size={isScreenLarge == false ? "xs" : "sm"}
                placeholder=" /100 "
                {...editForm.getInputProps("marks")}
              />
              <NumberInput
                mt="sm"
                size={isScreenLarge == false ? "xs" : "sm"}
                label="Penalty"
                placeholder=""
                {...editForm.getInputProps("penalty")}
              />
              <Textarea
                label="Remarks"
                size={isScreenLarge == false ? "xs" : "sm"}
                placeholder="Any remarks"
                {...editForm.getInputProps("remarks")}
              />

              <Group position="right" mt="md">
                <Button
                  type="submit"
                  gradient={{ from: "#0063F8", to: "#3391FF" }}
                  variant="gradient"
                  style={{
                    backgroundColor: "#00FFF0",
                    fontSize: isScreenLarge == false ? "11px" : "15px",
                  }}
                >
                  Update
                </Button>
              </Group>
            </form>
          </div>
        </div>
      </Container>
    </>
  );
}
Grade.propTypes = {
  submission: PropTypes.any,
  isChange: PropTypes.any,
};
